import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import CollectionBrowser from "./browse/CollectionBrowser";
import CollectionNew from "./edit/CollectionNew";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { useSearch } from "../searchServices";
import withAuthorization from "../../auth/withAuthorization";
import { creatorRoles } from "../CreatorApplication";
import CollectionEdit from "./edit/CollectionEdit";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const initialSearchState = {
  appliedQuery: [],
  appliedFacets: [
    {
      name: "type",
      queryParam: "_type",
      terms: [
        {
          code: "COLLECTION",
        },
      ],
    },
    {
      name: "status",
      queryParam: "status",
      terms: [{ code: "(-status:* AND *:*)" }, { code: "status:*" }],
    },
  ],
  orderBy: null,
  orderDirection: "asc",
  appliedPublicationYearGroups: [],
  page: 0,
  noFacets: true,
};

// TODO: refactor edit dialog routing
// Setting withAuthorization to false to not show unauthorized screen because
// unauthorized screen flashes when navigating to and away from edit screen for non-Admin users
const AuthorizedRoute = withAuthorization(Route, false);

const CollectionView = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const history = useHistory();

  const [searchState, setSearchState] = useState(initialSearchState);

  const searchResults = useSearch(searchState);

  const handleSave = useCallback(() => {
    searchResults.refetch();
    history.goBack();
  }, [searchResults, history]);

  const handleCancel = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Container
      id="collection-view"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <Switch>
        <AuthorizedRoute exact path={`${path}`} roles={creatorRoles}>
          <CollectionBrowser
            searchState={searchState}
            onSearchStateChange={state => setSearchState(state)}
            searchResults={searchResults}
            onSaveSuccess={handleSave}
          />
        </AuthorizedRoute>
        <AuthorizedRoute path={`${path}/new`} roles={creatorRoles}>
          <CollectionNew
            onCancel={() => history.push("/creator/collections")}
          />
        </AuthorizedRoute>
        <AuthorizedRoute path={`${path}/:id`} roles={creatorRoles}>
          <CollectionEdit onCancel={handleCancel} />
        </AuthorizedRoute>
      </Switch>
    </Container>
  );
};

export default CollectionView;
